import * as React from 'react';
import FileUploader from '../../../../../common/components/FileUploader';
import * as FileTypeConstants from '../../../../../common/constants/FileTypeConstants';
import { FIELD_UPLOAD_REQUIRED} from '../../../../constants/ValidateConstant';
import {LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import Button from '../../../../../common/components/Button';
import {FilesUploadStepProps, FilesUploadStepState} from '../../../../types/mx/creditoReal/components';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES,} from '../../../../../common/constants/MimeTypeConstants';

class FilesUploadStepView extends React.Component<FilesUploadStepProps, FilesUploadStepState> {
    constructor(props) {
        super(props);
        // @ts-ignore
        this.state = {
            ifeFrontFilesError: this.props.ifeFrontFiles.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            ifeBackFilesError: this.props.ifeBackFiles.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            homeFilesError:  this.props.homeFiles.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            otherMonthFilesError: this.props.includeMonthlyIncomes && this.props.otherMonthFiles.length > 0 ?
                this.props.otherMonthFiles.map(x => x.length === 0 ? this.props.noIncomeProof ? null : FIELD_UPLOAD_REQUIRED : null) : [],
            showErrors: false
        };
        this.props.getLoanApplication();
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
        }, 200);
    }

    componentDidUpdate(prevProps, prevState) {
        const prevOtherMonthFiles = prevProps.otherMonthFiles.reduce((acc, va) => acc + va.length, 0);
        const currentOtherMonthFiles = this.props.otherMonthFiles.reduce((acc, va) => acc + va.length, 0);
        if (prevProps.ifeFrontFiles.length !== this.props.ifeFrontFiles.length) {
            this.setState({
                ifeFrontFilesError:
                    this.props.ifeFrontFiles.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        }
        if (prevProps.ifeBackFiles.length !== this.props.ifeBackFiles.length) {
            this.setState({
                ifeBackFilesError: this.props.ifeBackFiles.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        }
        if (prevProps.homeFiles.length !== this.props.homeFiles.length) {
            this.setState({
                homeFilesError: this.props.homeFiles.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        }
        if (prevOtherMonthFiles !== currentOtherMonthFiles &&
            prevProps.includeMonthlyIncomes) {
            this.setState({
                otherMonthFilesError: this.props.otherMonthFiles.length > 0 ?
                        this.props.otherMonthFiles.map(x => x.length === 0 ? this.props.noIncomeProof ? null : FIELD_UPLOAD_REQUIRED : null) : []
            });
        }
    }

    onDropIdentificationFiles = (accepted, type, section, error) => {
        this.setState({
            ifeFrontFilesError:
                section === FileTypeConstants.IFE_FRONT_SECTION ? error : this.state.ifeFrontFilesError,
            ifeBackFilesError:
                section === FileTypeConstants.IFE_BACK_SECTION ? error : this.state.ifeBackFilesError
        });
        this.props.onDropIdentificationFiles(accepted, type, section, error);
    }

    onDropHomeFiles = (accepted, type, section, error) => {
        this.setState({homeFilesError: error});
        this.props.onDropHomeFiles(accepted, type, section, error);
    }

    onDropOtherFiles = (indexDropped) => (accepted, type, section, error) => {
        this.setState({
            otherMonthFilesError: this.state.otherMonthFilesError.map((x, index) => {
                if (index === indexDropped) {
                    return error;
                }
                return x;
            })
        });
        this.props.onDropOtherFiles(accepted, type, section, error);
    }

    validateFields = () => this.state.ifeFrontFilesError == null &&
        this.state.ifeBackFilesError == null &&
        this.state.homeFilesError == null &&
        this.state.otherMonthFilesError.every(x => x == null)

    onPressNext = () => {
        if (this.validateFields()) {
            this.props.onPressNext();
        } else {
            this.setState({
                showErrors: true
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="row d-none d-sm-none d-md-block">
                    <div className="col">
                        <h3 className="text-raleway text-secondary-lighten-1">
                            {LOAN_APPLICATION_MX.TITLE_FILE_UPLOAD}
                        </h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col mb-2">
                        <p>{LOAN_APPLICATION_MX.FILE_UPLOAD_DETAIL}</p>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col">
                        <div className="header-bar">{LOAN_APPLICATION_MX.FILE_UPLOAD_IDENTIFICATION}</div>
                    </div>
                </div>
                <div
                    className="row border-attention m-0 py-3 mb-4 d-flex align-items-center"
                >
                    <div className="col p-0 text-center icon-attention">
                        <img src={AssetsManager('/assets/images/common/attention-icon.svg')} alt="Attention"/>
                    </div>
                    <div className="col p-0 input-text-enabled">
                        {LOAN_APPLICATION_MX.FILE_UPLOAD_IDENTIFICATION_EXAMPLE}
                    </div>
                </div>
                <div className="row mb-4 justify-content-start">
                    <div className="col-md-3 col-sm-4">
                        <FileUploader
                            id="ifeFront"
                            type={FileTypeConstants.IDENTIFICATION_TYPE}
                            section={FileTypeConstants.IFE_FRONT_SECTION}
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            required={true}
                            multiple={false}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_BOX_FRONT}
                            onDrop={this.onDropIdentificationFiles}
                            onDelete={this.props.onDeleteIdentificationFile}
                            onClickThumbnail={this.props.onClickThumbnail}
                            uploadedFiles={this.props.ifeFrontFiles}
                            hasError={this.state.showErrors}
                            labelError={this.state.ifeFrontFilesError}/>
                    </div>

                    <div className="col-md-3 col-sm-4">
                        <FileUploader
                            id="ifeBack"
                            type={FileTypeConstants.IDENTIFICATION_BACK_TYPE}
                            section={FileTypeConstants.IFE_BACK_SECTION}
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            required={true}
                            multiple={false}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_BOX_BACK}
                            onDrop={this.onDropIdentificationFiles}
                            onDelete={this.props.onDeleteIdentificationFile}
                            onClickThumbnail={this.props.onClickThumbnail}
                            uploadedFiles={this.props.ifeBackFiles}
                            hasError={this.state.showErrors}
                            labelError={this.state.ifeBackFilesError}/>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col">
                        <div className="header-bar">{LOAN_APPLICATION_MX.FILE_UPLOAD_HOME}</div>
                    </div>
                </div>
                <div
                    className="row border-attention m-0 py-3 mb-4 d-flex align-items-center"
                >
                    <div className="col p-0 text-center icon-attention">
                        <img src={AssetsManager('/assets/images/common/attention-icon.svg')} alt="Attention"/>
                    </div>
                    <div className="col p-0 input-text-enabled">
                        {LOAN_APPLICATION_MX.FILE_UPLOAD_HOME_EXAMPLE}
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-md-3 col-sm-4">
                        <FileUploader
                            id="homeFiles"
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            type={FileTypeConstants.HOME_TYPE}
                            section={FileTypeConstants.HOME_SECTION}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_HOME_BOX}
                            required={true}
                            multiple={false}
                            onDrop={this.onDropHomeFiles}
                            onDelete={this.props.onDeleteHomeFile}
                            onClickThumbnail={this.props.onClickThumbnail}
                            uploadedFiles={this.props.homeFiles}
                            hasError={this.state.showErrors}
                            labelError={this.state.homeFilesError}/>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col">
                        <div className="header-bar">
                            {LOAN_APPLICATION_MX.FILE_UPLOAD_OTHER}
                            {this.props.includeMonthlyIncomes ? '' : LOAN_APPLICATION_MX.FILE_UPLOAD_OTHER_OPTIONAL}
                        </div>
                    </div>
                </div>
                <div
                    className="row border-attention m-0 py-3 mb-4 d-flex align-items-center"
                >
                    <div className="col p-0 text-center icon-attention">
                        <img src={AssetsManager('/assets/images/common/attention-icon.svg')} alt="Attention"/>
                    </div>
                    <div className="col p-0 input-text-enabled">
                        {LOAN_APPLICATION_MX.FILE_UPLOAD_OTHER_EXAMPLE}
                    </div>
                </div>
                <div className="row mb-4">
                    {this.props.otherMonthFiles.map((otherMonthFiles, index) => (
                        <div className="col-md-3 col-sm-4" key={`other-file-${index}`}>
                            <FileUploader
                                accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                                type={FileTypeConstants.OTHER_TYPE}
                                id={FileTypeConstants.INCOMES_NTH_SECTION(index + 1)}
                                key={FileTypeConstants.INCOMES_NTH_SECTION(index + 1)}
                                section={FileTypeConstants.INCOMES_NTH_SECTION(index + 1)}
                                multiple={false}
                                label={LOAN_APPLICATION_MX.FILE_UPLOAD_OTHER_BOX_TH(index + 1)}
                                onDrop={this.onDropOtherFiles(index)}
                                onDelete={this.props.onDeleteOtherFile}
                                uploadedFiles={otherMonthFiles}
                                onClickThumbnail={this.props.onClickThumbnail}
                                hasError={this.state.showErrors}
                                required={!!this.state.otherMonthFilesError[index]}
                                labelError={this.state.otherMonthFilesError[index]}/>
                        </div>
                    ))}
                </div>

                <div className="row border-top pt-4 mb-3">
                    <div className="col-12 d-flex justify-content-between">
                        <Button text={LOAN_APPLICATION_MX.NEXT}
                                onPress={() => this.onPressNext()} role="button"
                                customClass="ml-auto px-md-5 btn-block"/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default FilesUploadStepView;
